import { _SET_PHONE_NUMBER_VALUE } from "./mutations"

export const SET_PHONE_NUMBER_VALUE = "setPhoneNumberValue"

export default {
  [SET_PHONE_NUMBER_VALUE]({ commit }, phoneNumberValue: number) {
    commit(_SET_PHONE_NUMBER_VALUE, phoneNumberValue)
  }
}
